document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll('[data-carousel]');

  carousels.forEach((carouselWrapper) => {
    const track = carouselWrapper.querySelector('.customRSProductCard-carousel-track');
    const slides = carouselWrapper.querySelectorAll('.customRSProductCard-carousel-slide');
    const dots = carouselWrapper.querySelectorAll('.customRSProductCard-dot');
    const prevBtn = carouselWrapper.querySelector('.customRSProductCard-carousel-prev');
    const nextBtn = carouselWrapper.querySelector('.customRSProductCard-carousel-next');
    let currentIndex = 0;

    const goToSlide = (index) => {
      track.style.transform = `translateX(-${index * 100}%)`;
      currentIndex = index;

      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[index]) dots[index].classList.add('active');
    };

    nextBtn?.addEventListener('click', (e) => {
      e.stopPropagation(); // prevent link click
      const next = (currentIndex + 1) % slides.length;
      goToSlide(next);
    });

    prevBtn?.addEventListener('click', (e) => {
      e.stopPropagation();
      const prev = (currentIndex - 1 + slides.length) % slides.length;
      goToSlide(prev);
    });

    dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        e.stopPropagation();
        const index = parseInt(dot.getAttribute('data-index'), 10);
        goToSlide(index);
      });
    });

    // Prevent inner carousel swipe from triggering outer swipe
    ['touchstart', 'touchmove', 'touchend'].forEach(eventType => {
      track.addEventListener(eventType, e => e.stopPropagation(), { passive: true });
    });

    goToSlide(0);
  });
});


/* Initialize ALL product cards on the page, idempotently */
(() => {
  const inited = new WeakSet();

  function initCard(card){
    if (!card || inited.has(card)) return;
    inited.add(card);

    // --- Parse product JSON (scoped) ---
    let product = {};
    try { product = JSON.parse(card.querySelector('.customRSProductCard-json')?.textContent || '{}'); } catch(e){}

    // --- Nodes (scoped) ---
    const priceWrap = card.querySelector('[data-price]');
    const priceNow  = card.querySelector('[data-price-now]');
    const priceWas  = card.querySelector('[data-price-was]');
    const cardLink  = card.querySelector('.customRSProductCard-card-link');

    const mainBtn   = card.querySelector('.customRSProductCard-atc[data-mode]');
    const mode      = mainBtn?.getAttribute('data-mode') || '';
    const panel     = card.querySelector('.customRSProductCard-variants');
    const selects   = Array.from(card.querySelectorAll('.customRSProductCard-optSelect'));
    const msgEl     = card.querySelector('[data-variant-msg]');
    const inlineBtn = card.querySelector('.customRSProductCard-variants .customRSProductCard-atc.add');

    // --- Price animation config ---
    const ANIM_MULT = Math.max(1, parseFloat(priceWrap?.dataset.priceAnimMult || '2'));
    const ANIM_MS   = Math.max(0, parseInt(priceWrap?.dataset.priceAnimMs || '300', 10));

    function formatMoney(cents){
      if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
      try { return (cents/100).toLocaleString(undefined, { style:'currency', currency: '{{ shop.currency }}' }); }
      catch { return '₹' + (cents/100).toFixed(2); }
    }
    const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
    function animateCents(fromCents, toCents, { duration=300, onUpdate } = {}){
      if (duration <= 0) { onUpdate && onUpdate(toCents); return; }
      const start = performance.now();
      function frame(now){
        const t = Math.min(1, (now - start) / duration);
        const eased = easeOutCubic(t);
        const val = Math.round(fromCents + (toCents - fromCents) * eased);
        onUpdate && onUpdate(val);
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function paintPrice(variant){
      if (!variant) return;
      const unit = variant.price || 0;
      const from = Math.max(0, Math.round(unit * ANIM_MULT));
      animateCents(from, unit, {
        duration: ANIM_MS,
        onUpdate: (c) => { if (priceNow) priceNow.textContent = formatMoney(c); }
      });
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > unit) {
          priceWas.textContent = formatMoney(variant.compare_at_price);
          priceWas.classList.remove('is-hidden');
        } else {
          priceWas.textContent = '';
          priceWas.classList.add('is-hidden');
        }
      }
    }

    function selectionComplete(opts, count){ return opts.length === count && opts.every(v => v != null && v !== ''); }
    function findVariantByOptions(selected){
      return (product.variants || []).find(v =>
        (v.options || []).every((val, idx) => String(val) === String(selected[idx]))
      ) || null;
    }
    function getSelectedArray(){
      const arr = [];
      selects.forEach(sel => { arr[parseInt(sel.dataset.optIndex,10)] = sel.value; });
      return arr;
    }

    // Smooth open/close
    function openPanel(){
      if (!panel) return;
      panel.hidden = false;
      panel.classList.add('is-opening');
      panel.style.maxHeight = '0px'; panel.offsetHeight;
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.addEventListener('transitionend', function te(e){
        if (e.propertyName === 'max-height') {
          panel.classList.remove('is-opening');
          panel.classList.add('is-open');
          panel.style.maxHeight = 'none';
          panel.removeEventListener('transitionend', te);
        }
      });
      mainBtn?.setAttribute('aria-expanded','true');
      if (cardLink) cardLink.style.pointerEvents = 'none';
    }
    function closePanel(){
      if (!panel) return;
      panel.style.maxHeight = panel.scrollHeight + 'px'; panel.offsetHeight;
      panel.classList.remove('is-open');
      panel.style.maxHeight = '0px';
      panel.addEventListener('transitionend', function tc(e){
        if (e.propertyName === 'max-height') {
          panel.hidden = true;
          panel.style.maxHeight = null;
          panel.removeEventListener('transitionend', tc);
        }
      });
      mainBtn?.setAttribute('aria-expanded','false');
      if (cardLink) cardLink.style.pointerEvents = '';
    }

    // SINGLE VARIANT
    if (mode === 'single') {
      const vid = Number(mainBtn.getAttribute('data-variant-id'));
      mainBtn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (!vid) return;
        mainBtn.disabled = true;
        fetch('/cart/add.js', {
          method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
        .then(r => r.json())
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          mainBtn.textContent = 'ADDED!';
          setTimeout(() => { mainBtn.textContent = 'ADD TO CART — ' + (priceNow?.textContent || ''); }, 900);
        })
        .catch(() => {
          mainBtn.textContent = 'ERROR';
          setTimeout(() => { mainBtn.textContent = 'ADD TO CART — ' + (priceNow?.textContent || ''); }, 1200);
        })
        .finally(() => { mainBtn.disabled = false; });
      });
      return; // done for this card
    }

    // MULTI VARIANT
    function updateInlineButton(variant){
      if (!inlineBtn) return;
      if (!variant) {
        inlineBtn.disabled = true;
        inlineBtn.textContent = 'Select options';
        inlineBtn.removeAttribute('data-variant-id');
        return;
      }
      if (variant.available) {
        inlineBtn.disabled = false;
        inlineBtn.setAttribute('data-variant-id', variant.id);
        inlineBtn.textContent = 'ADD TO CART — ' + formatMoney(variant.price || 0);
      } else {
        inlineBtn.disabled = true;
        inlineBtn.textContent = 'Sold Out';
        inlineBtn.removeAttribute('data-variant-id');
      }
    }

    function updateUIFromSelection(){
      const opts = getSelectedArray();
      const variant = selectionComplete(opts, (product.options || []).length) ? findVariantByOptions(opts) : null;

      if (!variant) {
        updateInlineButton(null);
        if (msgEl) msgEl.textContent = '';
        return;
      }
      paintPrice(variant);
      updateInlineButton(variant);
      if (msgEl) msgEl.textContent = '';
    }

    if (mainBtn && panel) {
      mainBtn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const expanded = mainBtn.getAttribute('aria-expanded') === 'true';
        if (expanded) closePanel(); else { openPanel(); updateUIFromSelection(); }
      });
    }

    selects.forEach(sel => {
      sel.addEventListener('change', updateUIFromSelection);
      sel.addEventListener('input', updateUIFromSelection);
      sel.addEventListener('click', ev => ev.stopPropagation());
      sel.addEventListener('touchstart', ev => ev.stopPropagation(), { passive: true });
    });

    if (inlineBtn) {
      inlineBtn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const vid = Number(inlineBtn.getAttribute('data-variant-id') || 0);
        if (!vid) return;
        inlineBtn.disabled = true;
        fetch('/cart/add.js', {
          method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
        .then(r => r.json())
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          inlineBtn.textContent = 'ADDED!';
          setTimeout(updateUIFromSelection, 900);
        })
        .catch(() => {
          inlineBtn.textContent = 'ERROR';
          setTimeout(updateUIFromSelection, 1200);
        })
        .finally(() => { inlineBtn.disabled = false; });
      });
    }

    // Keep clicks inside panel from navigating
    panel?.addEventListener('click', ev => ev.stopPropagation());

    // Initial paint
    updateUIFromSelection();
  }

  function initAll(){ document.querySelectorAll('.customRSProductCard-card').forEach(initCard); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  // Re-init on dynamic section render (Shopify)
  document.addEventListener('shopify:section:load', initAll);

  // Hook fetch once per page to refresh drawer after add
  (function hookFetchOnce(){
    if (window.__pcFetchHook2) return; window.__pcFetchHook2 = true;
    const _fetch = window.fetch;
    window.fetch = function(input, init){
      const url = typeof input === 'string' ? input : input?.url || '';
      return _fetch(input, init).then(res => {
        if (url.includes('/cart/add.js') && res.ok) {
          setTimeout(() => document.dispatchEvent(new CustomEvent('cart:refresh')), 0);
        }
        return res;
      });
    };
  })();
})();